module.exports = __webpack_public_path__ + "static/img/ppt1.6a4d2c25.jpeg";